import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[stineComponentHost]',
  standalone: true,
})
export class ComponentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
